import Rollbar, { type Configuration } from 'rollbar'
import { currentEnv } from './detect-env'

// The token here is a Rollbar post_client_item token: it can only *create*
// items, so it is not a secret and is fine to embed (same as the auth0
// clientId/domain pattern).
const envTokens: Record<string, string> = {
  staging: '',
  production:
    '2280e22739d042f887784b3ee38e1e993c04456096bbd9394ae150c1f7e496b54beb9b754ed31fefbb458b490e276d55',
}

const accessToken = envTokens[currentEnv] ?? ''

// Baked at build time from Heroku's SOURCE_VERSION (git SHA). Identifies the
// build, not the environment, so a single value across envs is correct. Must
// match the code_version used when uploading source maps to Rollbar.
const codeVersion = __APP_VERSION__

export const isRollbarEnabled = Boolean(accessToken)

export const rollbarConfig: Configuration = {
  accessToken,
  environment: currentEnv,
  enabled: isRollbarEnabled,
  // Global handlers catch what React's ErrorBoundary can't (async, event handlers).
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Collapse identical errors fired in a tight loop into one item.
  ignoreDuplicateErrors: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: codeVersion,
        // Let Rollbar reconstruct frames for errors missing a stack.
        guess_uncaught_frames: true,
      },
    },
  },
}

// Single shared instance. The @rollbar/react Provider and the axios interceptor
// both use this one — two instances would each own the global uncaught/
// unhandledrejection handlers and double-report every such error.
export const rollbar = new Rollbar(rollbarConfig)
